import React from 'react'
import './heading.css'

const Heading = () => {
  return (
    <>
      <h1 className='heading'>URL Shortner</h1>
      <p className='intro'>Get rid of long URLs. Shorten Here.</p>
    </>
  )
}

export default Heading